module.exports = __webpack_public_path__ + "media/images/athletes/3958-48e359783ced70d03acf61c245c59f04.png";